var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolC2Pa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.792 0.114857C13.0874 -0.0164081 13.4187 -0.0351602 13.7243 0.0586003L13.8748 0.114857L25.8748 5.44656C26.3574 5.661 26.6633 6.13707 26.6667 6.65565L26.6586 6.81228L25.8953 13.6811C25.5052 17.1922 23.5892 20.3456 20.67 22.3105L20.3287 22.5319L14.04 26.4624C13.6557 26.7026 13.1796 26.7293 12.7748 26.5424L12.6267 26.4624L6.33802 22.5319C3.34237 20.6597 1.32988 17.5669 0.823161 14.0846L0.771406 13.6811L0.00819963 6.81228C-0.0501214 6.28739 0.206612 5.78309 0.652637 5.51852L0.791998 5.44656L12.792 0.114857ZM13.3334 2.79235L2.76629 7.4874L3.42176 13.3867C3.72315 16.0992 5.19552 18.5373 7.44047 20.0676L7.75135 20.2706L13.3334 23.7594L18.9154 20.2706C21.2298 18.8241 22.7897 16.441 23.1967 13.7548L23.245 13.3867L23.9005 7.4874L13.3334 2.79235ZM16.2849 8.508C16.7399 7.92897 17.5781 7.82839 18.1571 8.28334C18.6916 8.70329 18.8184 9.4498 18.4769 10.0176L18.3817 10.1555L13.0484 16.8221C12.5899 17.4058 11.7534 17.4955 11.1837 17.0528L11.0572 16.9412L8.39057 14.2745C7.86987 13.7538 7.86987 12.9096 8.39057 12.3889C8.87121 11.9083 9.62752 11.8713 10.1506 12.278L10.2762 12.3889L11.8801 13.9928L16.2849 8.508Z",
    fill: "#0057D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolC2Pa);
export default __webpack_public_path__ + "static/media/icon-sol-c2pa.a79c8aaa7ef7459963deaa9c54a40d7f.svg";
export { ForwardRef as ReactComponent };